/**
 * CardLine Games - Product Form JavaScript
 * Handles variant selection, image switching, price updates on product pages.
 * Loaded only on product template pages via theme.liquid.
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-id]').forEach(function (section) {
      var jsonEl = section.querySelector('[data-product-json]');
      if (!jsonEl) return;

      var productJson;
      try {
        productJson = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      initProductSection(section, productJson);
    });
  });

  function initProductSection(section, product) {
    var variantIdInput = section.querySelector('input[name="id"]');
    var mainImage = section.querySelector('.product__main-image');
    var addToCartBtn = section.querySelector('[data-add-to-cart]');
    var addToCartText = addToCartBtn ? addToCartBtn.querySelector('[data-add-to-cart-text]') : null;
    var priceWrapper = section.querySelector('.product__price-wrapper');
    var thumbnails = section.querySelectorAll('.product__thumbnail');
    var optionBtns = section.querySelectorAll('.product__option-btn');

    // Thumbnail click
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.src = this.dataset.imageUrl;
        mainImage.srcset = this.dataset.imageSrcset || '';
        mainImage.alt = this.dataset.imageAlt || '';
        thumbnails.forEach(function (t) {
          t.classList.remove('product__thumbnail--active');
          t.setAttribute('aria-current', 'false');
        });
        this.classList.add('product__thumbnail--active');
        this.setAttribute('aria-current', 'true');
      });
    });

    // Variant option buttons
    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Update active state
        var siblings = this.closest('.product__option-values').querySelectorAll('.product__option-btn');
        siblings.forEach(function (s) {
          s.classList.remove('product__option-btn--active');
          s.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('product__option-btn--active');
        this.setAttribute('aria-pressed', 'true');

        // Build selected options
        var selectedOptions = [];
        section.querySelectorAll('.product__option').forEach(function (optGroup) {
          var active = optGroup.querySelector('.product__option-btn--active');
          if (active) selectedOptions.push(active.dataset.optionValue);
        });

        // Find matching variant
        var variant = product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
        });

        if (variant) {
          onVariantChange(variant);
        }
      });
    });

    // Quantity buttons
    var qtyInput = section.querySelector('[data-quantity-input]');
    var minusBtn = section.querySelector('[data-quantity-minus]');
    var plusBtn = section.querySelector('[data-quantity-plus]');

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value) || 1;
        var max = qtyInput.hasAttribute('max') ? parseInt(qtyInput.getAttribute('max')) : Infinity;
        if (val < max) {
          qtyInput.value = val + 1;
        }
      });
    }

    // Copy link
    var copyBtn = section.querySelector('.product__share-copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = this.dataset.copyUrl;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            if (window.Toast) {
              window.Toast.show('Link copied!', 'success');
            }
          });
        }
      });
    }

    function onVariantChange(variant) {
      // Update hidden input
      if (variantIdInput) variantIdInput.value = variant.id;

      // Update URL
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Update button state
      if (addToCartBtn && addToCartText) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartText.textContent = window.theme.strings.addToCart || 'Add to Cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartText.textContent = window.theme.strings.soldOut || 'Agotado';
        }
      }

      // Update price via section rendering
      if (priceWrapper) {
        updatePrice(priceWrapper, variant);
      }

      // Update main image
      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.alt = variant.featured_image.alt || '';

        // Highlight matching thumbnail
        thumbnails.forEach(function (thumb) {
          thumb.classList.remove('product__thumbnail--active');
          thumb.setAttribute('aria-current', 'false');
        });

        var matchingThumb = Array.from(thumbnails).find(function (thumb) {
          return thumb.dataset.imageUrl && thumb.dataset.imageUrl.indexOf(variant.featured_image.src.split('?')[0].split('/').pop().split('.')[0]) > -1;
        });

        if (matchingThumb) {
          matchingThumb.classList.add('product__thumbnail--active');
          matchingThumb.setAttribute('aria-current', 'true');
        }
      }
    }

    function updatePrice(wrapper, variant) {
      var moneyFormat = window.theme.moneyFormat || '${{amount}}';

      var html = '<div class="price';
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (onSale) html += ' price--on-sale';
      if (!variant.available) html += ' price--sold-out';
      html += '">';

      if (variant.available) {
        html += '<div class="price__regular"><span class="price__current">' + formatMoney(variant.price, moneyFormat) + '</span></div>';
        if (onSale) {
          html += '<div class="price__compare"><s class="price__was">' + formatMoney(variant.compare_at_price, moneyFormat) + '</s></div>';
          var savingsPercent = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          html += '<span class="price__badge-sale">-' + savingsPercent + '%</span>';
        }
      } else {
        html += '<span class="price__sold-out">' + ((window.theme.strings && window.theme.strings.soldOut) || 'Agotado') + '</span>';
        html += '<span class="price__current price__current--faded">' + formatMoney(variant.price, moneyFormat) + '</span>';
      }

      html += '</div>';
      wrapper.innerHTML = html;
    }
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.floor(cents / 100);

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);

    if (!match) return '$' + amount;

    switch (match[1]) {
      case 'amount':
        value = format.replace(placeholderRegex, addCommas(amount));
        break;
      case 'amount_no_decimals':
        value = format.replace(placeholderRegex, addCommas(amountNoDecimals));
        break;
      case 'amount_with_comma_separator':
        value = format.replace(placeholderRegex, amount.replace('.', ','));
        break;
      default:
        value = format.replace(placeholderRegex, amount);
    }

    return value;
  }

  function addCommas(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
})();
